<template>
  <div class="tw:flex tw:flex-col tw:gap-4" data-testid="reg-company-brand">
    <span class="tw:flex tw:flex-col tw:gap-0.5">
      <span class="tw:text-13 tw:font-semibold tw:text-gray-900">{{ $t('registration.company.section_brand') }}</span>
      <span class="tw:text-13 tw:text-muted">{{ $t('registration.company.section_brand_hint') }}</span>
    </span>

    <div class="tw:grid tw:grid-cols-1 tw:items-start tw:gap-6 tw:sm:grid-cols-[220px_1fr]">
      <LogoUploadField v-model:logo-id="draft.logoId" :existing-logo-url="existingLogoUrl" />

      <BrandColorFields v-model="draft.brandColors" data-testid="reg-brand-colours" />
    </div>
  </div>
</template>

<script setup lang="ts">
/** The company step's brand section: logo upload and brand colours. */
import BrandColorFields from '@/components/generic/BrandColorFields.vue';
import LogoUploadField from '@/components/registration/subcomponents/LogoUploadField.vue';
import type { RegistrationDraft } from '@/types/registration';

/* ----------------------------------- STATE ---------------------------------- */
const draft = defineModel<RegistrationDraft['company']>('draft', { required: true });

/** thumbnail of a logo hydrated from a previous visit; arrives after mount */
defineProps<{ existingLogoUrl?: string | null }>();
</script>
